import React, { useEffect, useState } from "react";
import { Box, Typography, Card, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "../../redux/store";
import { getTripUpdate } from "../../redux/slices/common";

// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const R = 6371;
//   const toRad = (value) => (value * Math.PI) / 180;
//   const dLat = toRad(lat2 - lat1);
//   const dLon = toRad(lon2 - lon1);

//   const a =
//     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//     Math.cos(toRad(lat1)) *
//     Math.cos(toRad(lat2)) *
//     Math.sin(dLon / 2) *
//     Math.sin(dLon / 2);

//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };


// ✅ Replace the old calculateDistance with this version

const loadGoogleMapsScript = () => {
  return new Promise((resolve, reject) => {
    if (window.google?.maps?.DirectionsService) {
      // Already loaded
      resolve();
      return;
    }

    // Check if a script is already loading
    const existingScript = document.getElementById("google-maps-script");
    if (existingScript) {
      existingScript.onload = resolve;
      existingScript.onerror = reject;
      return;
    }

    // Create script dynamically
    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.MAPKEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

const calculateDrivingDistance = async (origin, destination) => {
  console.log("called", origin, destination);

  try {
    // Ensure API is ready
    await loadGoogleMapsScript();

    if (!window.google?.maps?.DirectionsService) {
      console.error("❌ Google Maps not initialized properly");
      return 0;
    }

    const directionsService = new window.google.maps.DirectionsService();
    const safePoint = (p) => ({
      lat: Number(p.lat),
      lng: Number(p.lng),
    });

    return new Promise((resolve, reject) => {
      directionsService.route(
        {
          origin: safePoint(origin),
          destination: safePoint(destination),
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          console.log("📡 DirectionsService status:", status);
          if (status === "OK") {
            const leg = result.routes[0].legs[0];
            const distanceInKm = leg.distance.value / 1000;
            console.log("✅ Distance:", distanceInKm);
            resolve(distanceInKm);
          } else {
            console.error("❌ Directions request failed:", status);
            reject(status);
          }
        }
      );
    });
  } catch (err) {
    console.error("💥 Error in calculateDrivingDistance:", err);
    return 0;
  }
};





const DriverStatusCard = ({ show, tripId, onClose }) => {
  const dispatch = useDispatch();
  const { tripUpdateRes } = useSelector((state) => state.common);

  const [datas, setDatas] = useState(null);
  const [progress, setProgress] = useState(0);
  const [lastDriverDistance, setLastDriverDistance] = useState(null);

  // 🔁 1. Set up polling timer for getTripUpdate
  useEffect(() => {
    if (!show || !tripId) return;

    const passengerId = JSON.parse(sessionStorage.getItem("rslkeyId"));
    const userId = JSON.parse(sessionStorage.getItem("rslkey"));
    const phone = JSON.parse(sessionStorage.getItem("phone"));
    const countryCode = JSON.parse(sessionStorage.getItem("countryCode"));
    const userName = JSON.parse(sessionStorage.getItem("userName"));
    const userEmail = JSON.parse(sessionStorage.getItem("userEmail"));

    if (!passengerId) return;

    const fetchTripUpdate = () => {
      const obj = {
        userId,
        passenger_id: passengerId,
        request_type: "0",
        trip_id: tripId,
        phone,
        countryCode,
        name: userName,
        email: userEmail,
        type: 0,
      };
      dispatch(getTripUpdate(obj));
    };

    fetchTripUpdate();
    const interval = setInterval(fetchTripUpdate, 5000);

    return () => clearInterval(interval);
  }, [dispatch, show, tripId]);

  console.log("tripUpdateRes", tripUpdateRes);


  useEffect(() => {
    if (!tripUpdateRes) return;
    const driver = tripUpdateRes?.detail?.driverdetails;

    setDatas({
      trip_id: tripUpdateRes?.detail?.trip_id,
      model_name: driver?.motor_model_info?.model_name,
      taxi_no: driver?.taxi_no,
      travel_status: driver?.travel_status,
      pickup_date_time: tripUpdateRes?.detail?.pickup_date_time || driver?.pickup_time,
      message:
        tripUpdateRes?.detail?.travel_status_message ||
        tripUpdateRes?.message,
      pickup_lat: driver?.pickup_latitude,
      pickup_lng: driver?.pickup_longitude,
      drop_lat: driver?.drop_latitude,
      drop_lng: driver?.drop_longitude,
      driver_lat: driver?.current_latitude,
      driver_lng: driver?.current_longitude,
    });
  }, [tripUpdateRes]);

  // 3️⃣ Recalculate progress when driver 


  const [initialDriverPos, setInitialDriverPos] = useState(null);

  useEffect(() => {
    if (datas?.travel_status === 12 && !initialDriverPos) {
      setInitialDriverPos({ lat: datas.driver_lat, lng: datas.driver_lng });
    }
  }, [datas]);

  // useEffect(() => {
  //   if (!datas) return;

  //   const {
  //     pickup_lat,
  //     pickup_lng,
  //     drop_lat,
  //     drop_lng,
  //     driver_lat,
  //     driver_lng,
  //     travel_status,
  //   } = datas;

  //   // Ensure all coordinates exist and are valid numbers
  //   if (
  //     !pickup_lat ||
  //     !pickup_lng ||
  //     !drop_lat ||
  //     !drop_lng ||
  //     !driver_lat ||
  //     !driver_lng
  //   )
  //     return;

  //   const fetchDrivingDistance = async () => {
  //     try {
  //       let totalDistance = 0;
  //       let remainingDistance = 0;

  //       // 🧭 Phase 1 — Driver on the way (status 12)
  //       if (travel_status === 12) {
  //         // Total route: driver → drop
  //         totalDistance = await calculateDrivingDistance(
  //           { lat: driver_lat, lng: driver_lng },
  //           { lat: pickup_lat, lng: pickup_lng }
  //         );

  //         // Remaining to pickup: driver → pickup
  //         remainingDistance = await calculateDrivingDistance(
  //           { lat: driver_lat, lng: driver_lng },
  //           { lat: pickup_lat, lng: pickup_lng }
  //         );
  //       }

  //       // 🚗 Phase 2 — Trip in progress (status 2)
  //       else if (travel_status === 2) {
  //         // Total: pickup → drop
  //         totalDistance = await calculateDrivingDistance(
  //           { lat: pickup_lat, lng: pickup_lng },
  //           { lat: drop_lat, lng: drop_lng }
  //         );

  //         // Remaining: driver → drop
  //         remainingDistance = await calculateDrivingDistance(
  //           { lat: driver_lat, lng: driver_lng },
  //           { lat: drop_lat, lng: drop_lng }
  //         );
  //       } else {
  //         return;
  //       }

  //       // 🧮 Update only if driver actually moved
  //       const distanceChange =
  //         lastDriverDistance !== null
  //           ? Math.abs(remainingDistance - lastDriverDistance)
  //           : 0;

  //           console.log("distanceChange:", distanceChange);

  //            console.log("lastDriverDistance:", lastDriverDistance);

  //       if (lastDriverDistance === null) {
  //         let distanceCovered = totalDistance - remainingDistance;
  //         console.log("distanceCovered:", distanceCovered);
  //         if (distanceCovered < 0) distanceCovered = 0;

  //         const progressPercent = Math.max(
  //           0,
  //           Math.min((distanceCovered / totalDistance) * 100, 100)
  //         );

  //         console.log("🗺️ totalDistance:", totalDistance.toFixed(2));
  //         console.log("🗺️ remainingDistance:", remainingDistance.toFixed(2));
  //         console.log("🗺️ progressPercent:", progressPercent.toFixed(2));

  //         setProgress(progressPercent);
  //         setLastDriverDistance(remainingDistance);
  //       }
  //     } catch (error) {
  //       console.error("❌ Error calculating route distance:", error);
  //     }
  //   };

  //   fetchDrivingDistance();
  // }, [datas, lastDriverDistance]);


  useEffect(() => {
    if (!datas) return;

    const {
      pickup_lat,
      pickup_lng,
      drop_lat,
      drop_lng,
      driver_lat,
      driver_lng,
      travel_status,
    } = datas;

    if (
      !pickup_lat ||
      !pickup_lng ||
      !drop_lat ||
      !drop_lng ||
      !driver_lat ||
      !driver_lng
    )
      return;

    const fetchDrivingDistance = async () => {
      try {
        let totalDistance = 0;
        let remainingDistance = 0;
        let progressPercent = 0;


        if (travel_status === 12) {
          const startPoint = initialDriverPos || { lat: driver_lat, lng: driver_lng };

          totalDistance = await calculateDrivingDistance(
            startPoint,
            { lat: pickup_lat, lng: pickup_lng }
          );

          remainingDistance = await calculateDrivingDistance(
            { lat: driver_lat, lng: driver_lng },
            { lat: pickup_lat, lng: pickup_lng }
          );
        }

        else if (travel_status === 2) {
          totalDistance = await calculateDrivingDistance(
            { lat: pickup_lat, lng: pickup_lng },
            { lat: drop_lat, lng: drop_lng }
          );

          remainingDistance = await calculateDrivingDistance(
            { lat: driver_lat, lng: driver_lng },
            { lat: drop_lat, lng: drop_lng }
          );
        } else {
          setProgress(0);
          return;
        }

        if (!totalDistance) return;

        const distanceCovered = Math.max(totalDistance - remainingDistance, 0);
        progressPercent = Math.min((distanceCovered / totalDistance) * 100, 100);

        console.log("🗺️ travel_status:", travel_status);
        console.log("🗺️ totalDistance:", totalDistance.toFixed(2));
        console.log("🗺️ remainingDistance:", remainingDistance.toFixed(2));
        console.log("🗺️ progressPercent:", progressPercent.toFixed(2));

        setProgress(progressPercent);
      } catch (error) {
        console.error("❌ Error calculating route distance:", error);
      }
    };

    fetchDrivingDistance();
  }, [datas]);



  console.log("progress", progress);

  if (!show || !datas) return null;


  console.log("datas", datas);

  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: "95%", sm: "90%", md: 400, lg: 500 },
        mx: "auto",
      }}
    >
      {/* 🚗 Driver Illustration */}
      <Box
        component="img"
        src="/img/header/driver.svg"
        alt="Driver"
        sx={{
          position: "absolute",
          top: { xs: "-45px", sm: "-40px", md: "-20px", lg: "-25px" },
          left: { xs: "50%", sm: "50%", md: "10px", lg: "20px" },
          transform: {
            xs: "translateX(-50%)",
            sm: "translateX(-50%)",
            md: "none",
            lg: "none",
          },
          height: { xs: "120px", sm: "150px", md: "177px", lg: "210px" },
          zIndex: 2,
          pointerEvents: "none",
          userSelect: "none",
        }}
      />

      <Card
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          alignItems: "center",
          gap: 2,
          backgroundColor: "#FFFFFF",
          border: "6px solid #45C2C4",
          borderRadius: "12px",
          p: { xs: 2, sm: 2.5, lg: 3 },
          pt: { xs: "100px", sm: "120px", md: "20px", lg: "25px" },
          pl: { xs: "20px", sm: "20px", md: "140px", lg: "160px" },
          boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
          overflow: "visible",
          textAlign: { xs: "center", sm: "center", md: "left" },
        }}
      >
        <Box sx={{ flex: 1, width: "100%" }}>

          <Typography
            variant="body2"
            sx={{
              color: "#333",
              fontWeight: 600,
              mb: 0.5,
              fontSize: "1.1rem",
            }}
          >
            {datas?.model_name ? `${datas.model_name} | ` : ""}
            {datas?.pickup_date_time}
          </Typography>


          <Typography
            variant="h6"
            sx={{
              background:
                "linear-gradient(to bottom, #75C4C5 0%, #0D8196 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 700,
              fontSize: "1.1rem",
              mb: 1,
              minHeight: "55px"
            }}
          >
            {datas.message}
          </Typography>

          {/* Car Info */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: { xs: "center", md: "flex-start" },
              gap: 1.5,
              mb: 1,
            }}
          >
            {datas?.taxi_no &&
              <Box
                sx={{
                  background:
                    "linear-gradient(to bottom, #75C4C5 0%, #0D8196 100%)",
                  borderRadius: "8px",
                  px: 1,
                  py: 0.5,
                  fontSize: "0.9rem",
                  color: "#fff",
                }}
              >
                Car No : {datas?.taxi_no || ""}
              </Box>
            }
            <Box
              sx={{
                background:
                  "linear-gradient(to bottom, #75C4C5 0%, #0D8196 100%)",
                borderRadius: "8px",
                px: 1,
                py: 0.5,
                fontSize: "0.9rem",
                color: "#fff",
              }}
            >
              Trip ID : {tripId}
            </Box>
          </Box>

          {/* 🚘 Progress bar */}
          {progress ? (
            <Box sx={{ position: "relative", mt: 2 }}>
              <Box
                sx={{
                  height: 10,
                  backgroundColor: "#E0E0E0",
                  borderRadius: 5,
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: `${progress}%`,
                    background:
                      "linear-gradient(90deg, #0098A4 0%, #42C2C3 70%, #75C4C5 100%)",
                    borderRadius: 5,
                    transition: "width 0.3s linear",
                  }}
                />
              </Box>

              <Box
                component="img"
                src="/img/header/car.svg"
                alt="Car"
                sx={{
                  position: "absolute",
                  top: "-34px",
                  marginLeft: "20px",
                  left: `${progress}%`,
                  width: { xs: 60, sm: 70, md: 80 },
                  transform: "translateX(-50%)",
                  transition: "left 0.3s linear",
                }}
              />
            </Box>
          ) : ('')}
        </Box>

        {/* ❌ Close Button */}
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#45C2C4",
            borderRadius: "6px",
            zIndex: 10,
            background:
              "linear-gradient(white, white) padding-box, linear-gradient(to top, #0098A4 0%, #42C2C3 70%, #75C4C5 100%) border-box",
            border: "2px solid transparent",
            width: 24,
            height: 24,
            "& svg": { fontSize: 14 },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Card>
    </Box>
  );
};

export default DriverStatusCard;
